var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardsPitch2Icon = function SvgCardsPitch2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cards-pitch-2_icon_svg__a)",
    fillRule: "evenodd",
    d: "M.573 4.323a.5.5 0 0 1 0-.707l.93-.93A8.25 8.25 0 1 1 13.17 14.354l-.93.93a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l.93-.93a6.75 6.75 0 0 0-9.546-9.546l-.93.93a.5.5 0 0 1-.707 0l-.354-.354Zm2.273 2.273a.5.5 0 0 1 0-.707l.93-.93a5.036 5.036 0 0 1 7.122 7.122l-.93.93a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707l.93-.93a3.536 3.536 0 1 0-5-5l-.93.93a.5.5 0 0 1-.707 0l-.354-.354Zm3.207.379a2 2 0 1 0 2.829 2.828 2 2 0 0 0-2.829-2.828Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cards-pitch-2_icon_svg__a",
    x1: 0.22,
    x2: 7.964,
    y1: 3.97,
    y2: -2.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
};
export default SvgCardsPitch2Icon;